import api, { unwrap } from './client';

export async function submitQuiz(payload) {
  return unwrap(await api.post('/quiz', payload));
}

export async function myLatestQuiz() {
  return unwrap(await api.get('/quiz/me/latest'));
}

export async function listAllQuizzes(params = {}) {
  return unwrap(await api.get('/quiz', { params }));
}

export async function getQuiz(id) {
  return unwrap(await api.get(`/quiz/${id}`));
}
